<template>
  <div class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>司機使用行為查看</h3>
          <hr />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h4 class="col-md-1">起始時間：</h4>
        <DateSelect ref="startTime"></DateSelect>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h4 class="col-md-1">結束時間：</h4>
        <DateSelect ref="endTime" :isEndTime="true"></DateSelect>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <h4 class="col-md-3">呼號/隊編:</h4>
        <input
          v-model="callNumber"
          type="text"
          required="required"
          class="inputstyle col-md-7 fontSize16"
          placeholder="隊編/呼號"
        />
        <button @click="getList" type="button" class="mybtnstyle btn-success">
          搜尋
        </button>
      </div>
    </div>
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-3">
          <label>
            <select
              v-model="npp"
              @change="getList"
              name="datatable-checkbox_length"
              aria-controls="datatable-checkbox"
              class="form-control input-sm tabletext"
            >
              <!-- <option :value="10">10</option> -->
              <option :value="25">25</option>
              <option :value="50">50</option>
              <option :value="100">100</option>
            </select>
          </label>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-striped jambo_table bulk_action">
          <thead>
            <tr class="headings">
              <th class="column-title word_center">序號</th>
              <th class="column-title word_center">隊編/呼號</th>
              <th class="column-title word_center">狀態</th>
              <th class="column-title word_center">種類</th>
              <th class="column-title word_center">訊息</th>
              <th class="column-title word_center">建立時間</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(row, index) in list">
              <tr
                v-if="total > 0"
                v-bind:class="{ even: index % 2 == 0, odd: index % 2 != 0 }"
                class="tabletext"
              >
                <td class="word_center">{{ index + 1 }}</td>
                <td class="word_center">{{ row.callNumber }}</td>
                <td class="word_center">{{ getDriverState(row.state) }}</td>
                <td class="word_center">{{ getDriverEvent(row.event) }}</td>
                <td class="word_center">{{ row.note }}</td>
                <td class="word_center">{{ row.createdAt }}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <el-pagination
        @current-change="clickNewPage"
        :current-page.sync="page"
        :page-size="npp"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
      <!-- <div class="pull-right">
        <ul class="pagination tabletext">
          <li v-bind:class="{ disabled: page == 1 }">
            <a href="javascript:;" @click="clickNewPage(1)" v-bind:class="{ active: page == 1 }">第一頁</a>
          </li>
          <li>
            <a href="javascript:;" @click="clickNewPage(pages_show_list[0] - 1)"
              v-show="page - 2 > 1 && pages_show_list[0] - 1 != 1">
              ...
            </a>
          </li>
          <li v-for="n in pages_show_list" v-bind:class="{ active: n == page }" @click="clickNewPage(n)">
            <a href="javascript:;" ng-bind="n">{{ n }}</a>
          </li>
          <li>
            <a href="javascript:;" @click="clickNewPage(pages_show_list[4] + 1)" v-show="page + 2 < totalPage && pages_show_list[4] + 1 < totalPage
              ">
              ...
            </a>
          </li>
          <li v-show="totalPage > 1" v-bind:class="{ disabled: page == totalPage }">
            <a href="javascript:;" @click="clickNewPage(totalPage)" v-bind:class="{ active: page == totalPage }">最後一頁</a>
          </li>
        </ul>
      </div> -->
    </div>
    <div class="x_content move_down"></div>
  </div>
</template>
<script>
import API from '../../assets/js/libs/API'
import Cookies from 'js-cookie'
import moment from 'moment'
import DateSelect from '../../components/tool/DateSelect'
import Vue from 'vue'
// Import component
import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'
import axios from 'axios'
// Init plugin
export default {
  name: 'DriverBehavior',
  components: {
    DateSelect,
  },
  data() {
    return {
      fullPage: false,
      loader: null,
      list: [],
      npp: 25,
      page: 1,
      callNumber: '',
      total: 0,
      totalPage: 0,
      path: '',
      queryPath: '',
    }
  },
  methods: {
    showLoading() {
      this.loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      })
    },
    getList(_, page = 1) {
      this.page = page
      if (this.callNumber === '') {
        alert('請輸入呼號')
      }
      const startTime = new Date(this.$refs.startTime.getDate()).getTime()
      const endTime = new Date(this.$refs.endTime.getDate()).getTime()
      const debugValue = this.$route.query.debug
      // debug值是為了讓工程師觀察隱藏的內容，需要在url加上debug的query
      // 目前的debug僅有1，未來或許增加其他的值
      const apiPath = `${API.getAPIUrl}driver/behavior?callNumber=${
        this.callNumber
      }&startDate=${startTime}&endDate=${endTime}&pageSize=${
        this.npp
      }&pageNumber=${page}${debugValue ? '&debug=' + debugValue : ''}`
      API.get(apiPath)
        .then((res) => {
          this.list = res.result.getBehaviorResult
          this.total = res.result.total
          this.totalPage = Math.ceil(res.result.total / this.npp)
        })
        .catch((error) => {
          console.error(error)
        })
    },
    clickNewPage(page) {
      this.page = page
      this.getList(_, page)
    },
    setTransactionPicked(value) {
      this.page = 1
      this.transactionTask = value
      this.getList()
    },
    getDriverEvent(value) {
      switch (value) {
        case 'click':
          return '點擊'
          break
        case 'receive':
          return '接收系統資訊'
          break
        case 'show':
          return '顯示'
          break
        case 'trigger':
          return '自動觸發'
          break
      }
    },
    getDriverState(value) {
      switch (value) {
        case 0:
          return '休息'
          break
        case 1:
          return '空車'
          break
        case 2:
          return '派遣中'
          break
        case 3:
          return '載客中'
          break
        case 4:
          return '排班中'
          break
        case 5:
          return '登出'
          break
        case 6:
          return '失聯'
          break
        case 7:
          return '停權車'
          break
      }
    },
  },
  computed: {
    pages_show_list: function () {
      var pages_show_list = []
      var totalPage = this.totalPage
      var newCurrent = this.page
      if (totalPage < 7) {
        for (var i = 2; i < totalPage; i++) {
          pages_show_list.push(i)
        }
      } else {
        if (newCurrent <= 4) {
          for (var i = 2; i < 7; i++) {
            pages_show_list.push(i)
          }
        } else if (newCurrent <= totalPage && newCurrent >= totalPage - 3) {
          for (var i = totalPage - 5; i < totalPage; i++) {
            pages_show_list.push(i)
          }
        } else {
          for (var i = -2; i < 3; i++) {
            pages_show_list.push(newCurrent + i)
          }
        }
      }
      return pages_show_list
    },
  },
  mounted() {},
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tabletext {
  color: black;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/driver/DriverBehavior.vue